import { useEffect, useState } from 'react';
import { useGetPostingDetails } from '../../../../../../domain/PermanentJobs';

export const useJobDetails = (jobId) => {
  const [job, setJob] = useState(null);

  const { data: currentJobPosting, isLoading } = useGetPostingDetails(
    { postingId: jobId },
    { enabled: !!jobId },
  );

  useEffect(() => {
    if (currentJobPosting) {
      setJob(currentJobPosting);
    }
  }, [currentJobPosting]);

  return {
    job,
    isLoading,
  };
};
